<template>
  <div class="m-pc-pager">
    <ul class="pager-right">
      <li class="pager-item" @click="first">
        <span class="icontemp shuangzuojiantou-"></span>
      </li>
      <li class="pager-item" :class="{ disable: index === 1 }" @click="prev">
        <span class="icontemp zuojiantou-"></span>
      </li>
      <li class="pager-item" v-if="index - (perPages - 1) / 2 > 1 && pages > 5">
        ...
      </li>
      <li
        class="pager-item"
        v-for="pager in pagers"
        :key="pager"
        :class="{ active: index == pager }"
        @click="go(pager)"
      >
        {{ pager }}
      </li>
      <li
        class="pager-item"
        v-if="index + (perPages - 1) / 2 < pages && pages > 5"
      >
        ...
      </li>
      <li
        class="pager-item"
        @click="last"
        v-if="index + (perPages - 1) / 2 < pages && pages > 5"
      >
        {{ pages }}
      </li>
      <li
        class="pager-item"
        :class="{ disable: index === pages }"
        @click="next"
      >
        <span class="icontemp youjiantou-"></span>
      </li>
      <li class="pager-item" @click="last">
        <span class="icontemp shuangyoujiantou-"></span>
      </li>
    </ul>
    <div class="pager-left">
      共 <span class="pager-total">{{ size }}</span> 条数据
    </div>
  </div>
</template>
<script>
export default {
  name: "Pager",
  data() {
    return {
      index: this.pageIndex, //当前页码
      limit: this.pageSize, //每页显示条数
      size: this.total || 1 //总记录数
      // showPrevMore : false,
      // showNextMore : false
    };
  },
  props: {
    ///当前可见页码
    perPages: {
      type: Number,
      default: 5
    },
    //当前页码
    pageIndex: {
      type: Number,
      default: 5
    },
    //每页显示条数
    pageSize: {
      type: Number,
      default: 10
    },
    //总记录数
    total: {
      type: Number,
      default: 5
    }
  },

  methods: {
    prev() {
      if (this.index > 1) {
        this.go(this.index - 1);
      }
    },
    next() {
      if (this.index < this.pages) {
        this.go(this.index + 1);
      }
    },
    first() {
      if (this.index !== 1) {
        this.go(1);
      }
    },
    last() {
      if (this.index != this.pages) {
        this.go(this.pages);
      }
    },
    go(page) {
      if (this.index !== page) {
        this.index = page;
        //父组件通过change方法来接受当前的页码
        this.$emit("change", this.index);
      }
    }
  },
  computed: {
    //计算总页码
    pages() {
      return Math.ceil(this.size / this.limit);
    },

    //计算页码，当count等变化时自动计算
    pagers() {
      const array = [];
      const perPages = this.perPages;
      const pageCount = this.pages;
      let current = this.index;
      const _offset = (perPages - 1) / 2;

      const offset = {
        start: current - _offset,
        end: current + _offset
      };

      //-1, 3
      if (offset.start < 1) {
        offset.end = offset.end + (1 - offset.start);
        offset.start = 1;
      }
      if (offset.end > pageCount) {
        offset.start = offset.start - (offset.end - pageCount);
        offset.end = pageCount;
      }
      if (offset.start < 1) offset.start = 1;

      // this.showPrevMore = (offset.start > 1);
      // this.showNextMore = (offset.end < pageCount);

      for (let i = offset.start; i <= offset.end; i++) {
        array.push(i);
      }

      return array;
    }
  },
  watch: {
    pageIndex(val) {
      this.index = val || 1;
    },
    pageSize(val) {
      this.limit = val || 10;
    },
    total(val) {
      this.size = val || 1;
    }
  },
  components: {}
};
</script>
